import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { checklistsClient } from '../../../utils/apollo/api'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'

const QUERY = gql`
  query Questions($search: String, $page: Int, $filter: QuestionFilter) {
    questions(
      search: $search
      page: $page
      filter: $filter
      sort: [
        { field: CHECKLIST_NAME, type: ASC }
        { field: CATEGORY_ORDINATION, type: ASC }
        { field: ORDINATION, type: ASC }
      ]
    ) {
      id
      name
      data
      typeName
      checklist {
        id
        name
      }
      category {
        id
        name
      }
    }
  }
`

export const useQuestionsLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: checklistsClient })
  return (search, page = 1) => {
    return query({ search, page, filter })?.then(pathOr([], ['data', 'questions']))
  }
}

const QuestionSelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useQuestionsLoader(filter)
  const handleGetOptions = (...params) => {
    return getOptions(...params).then(options => {
      return (options || []).map(option => ({
        ...option,
        description: `question_id: ${option.id} - ${option.checklist?.name} | ${option.category?.name}`
      }))
    })
  }

  return (
    <Select
      value={value} //
      onChange={onChange}
      options={handleGetOptions}
      descriptionField="description"
      {...props}
    />
  )
}

export default QuestionSelect
